import { configureStore } from "@reduxjs/toolkit";
import AuthSlice from "./Authslice.js";
import CartSlice from "./Cartslice.js";
import Frameslice from "./Frameslice.js";
import Homehmade from "../components/homeparts.js";
import Homehmadeslice from "./Homemadeslice.js";
import Potraitslice from "./Potraitslice.js";
import Bestsellerslice from "./Bestsellerslice.js";
import Productslice from "./Productslice.js";
import Singleproduct from "../components/Singleproduct.js";
import Singleproductslice from "./Singleproductslice.js";
import Carttslice from "./Carttslice.js";
const store = configureStore({
	reducer : {
		auth : AuthSlice.reducer,
		cart : CartSlice.reducer,
		frame : Frameslice.reducer,
		homemade: Homehmadeslice.reducer,
		potrait : Potraitslice.reducer,
		bestseller : Bestsellerslice.reducer,
		product : Productslice.reducer,
		singleproduct : Singleproductslice.reducer,
		cartt : Carttslice.reducer
	},


})
export default store;